module.exports = __webpack_public_path__ + "img/1071jdf2.46ad5c0e.png";